<template>
  <div class="relative">    
      <div v-show="isHidden">
          <a class="text-red-500 cursor-pointer hover:text-red-700 text-sm" v-on:click="isHidden = !isHidden">
              <i aria-hidden="true" class="material-icons align-middle text-sm">remove_circle</i> Delete
          </a>
      </div>
      <div v-if="!isHidden" class="delete-wrapper" v-click-outside="onClickOutside">
          <div class="confirm-delete-wrapper w-64 whitespace-normal p-3">
            {{confirmtext}}
            <button v-on:click="deleteItem" type="submit" class="commitbutton cursor-pointer"><i aria-hidden="true" class="material-icons align-middle text-xl">delete</i>Delete</button>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import vClickOutside from 'v-click-outside'

  export default {

        props: {
            value: '',
            route:'',
            confirmtext: {
              default: 'Are You Sure?',
            },
            redirect:'',
        },

        data() {
          return {
            isHidden: true,
            success: false,
            loaded: true,
          }
        },
        directives: {
          clickOutside: vClickOutside.directive
        },
        methods: {
          onClickOutside (event) {
              this.isHidden = !this.isHidden
              // console.log('Clicked outside. Event: ', event)
          },
          deleteItem: function (event) {
            let url = this.redirect;
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.delete(this.route,
              ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  window.location.href = url;
                })
            };
          }

        },
      };
</script>
